<div
    class="chip"
    *ngFor="let option of options; trackBy: trackByFn;"
    [ngbTooltip]="option.name"
    (click)="!disabled && remove(option)">
    {{option.name}}
</div>

<ng-content></ng-content>
